/* ============================================================
   BYG GARAGE — "merk dir mein Bike, dann sag mir was passt".

   WARUM ES DIESE DATEI GIBT.
   Im Shop stehen 3.850 Teile. Die Passung steht sauber an jedem
   Produkt (Metafeld byg.fitment: Marke, Modell, von, bis), aber bis
   jetzt musste sie jeder Kunde selbst aus dem Produkttitel lesen.
   Hier waehlt er sein Bike EINMAL, danach beantwortet jede
   Produktseite die Frage "passt das?" von allein.

   WAS HIER BEWUSST NICHT PASSIERT.
   - Kein Konto, keine Anmeldung, kein Server. Das Bike steht in
     localStorage und verlaesst das Geraet nicht.
   - KEIN RATEN. Ein Produkt ohne byg.fitment bekommt gar keine
     Aussage. 823 der 3.850 Artikel sind Oele, Werkzeug, Bekleidung
     und aehnliches — bei denen waere sowohl "passt" als auch "passt
     nicht" falsch, also sagen wir nichts.
   - Kein Blockieren. Die Garage WARNT, sie verbietet nichts. Wer ein
     Teil trotzdem will, kauft es; manchmal weiss der Kunde mehr als
     das Metafeld.

   DATENQUELLE: assets/byg-garage-index.json, erzeugt aus byg.fitment
   ueber alle aktiven Produkte. Form: { "KTM": { "250 SX": [1990, …,
   2027] } }. 14 Marken, 225 Marke-Modell-Paare. Wird die Datei nicht
   geladen, faellt der Waehler aus und die Seite bleibt heil.
   ============================================================ */
(function () {
  'use strict';

  var SCHLUESSEL = 'byg-garage';

  /* localStorage kann werfen: privates Fenster, gesperrte Website-Daten,
     Vorschau-Rahmen. Jeder Zugriff deshalb gekapselt — eine Garage, die
     sich nichts merken kann, ist unschoen, eine Seite die deswegen
     weiss bleibt ist ein Fehler. */
  /* ANSCHLUSS AN DEN BIKE-WAEHLER (05.10.2026). Der neue Einstieg auf
     /pages/shop merkt sich bis zu drei Motorraeder unter 'byg-bikes'
     ({ f: "KTM 125 SX", jahr }). Das aktive (erste) hat Vorrang vor dem
     alten Garage-Eintrag — sonst fragte diese Leiste nach einem Bike,
     das der Kunde gerade gewaehlt hat. Der Filterwert f wird hier in
     Marke und Modell zerlegt; zwei Marken haben zwei Woerter. */
  var NEU = 'byg-bikes';
  var ZWEIWORT = ['GAS GAS', 'TM RACING'];
  function ausNeu() {
    try {
      var l = JSON.parse(window.localStorage.getItem(NEU));
      if (!Array.isArray(l) || !l.length || !l[0] || !l[0].f) return null;
      var f = String(l[0].f), marke = '', modell = '';
      for (var i = 0; i < ZWEIWORT.length; i++) {
        if (f.indexOf(ZWEIWORT[i] + ' ') === 0) { marke = ZWEIWORT[i]; modell = f.slice(ZWEIWORT[i].length + 1); }
      }
      if (!marke) { var p = f.indexOf(' '); if (p < 1) return null; marke = f.slice(0, p); modell = f.slice(p + 1); }
      return { marke: marke, modell: modell, jahr: l[0].jahr || null };
    } catch (e) { return null; }
  }
  /* Zurueckschreiben, wenn jemand im alten Dialog waehlt. Der alte Index
     schreibt "GASGAS" und kennt noch gestrichene Modelle; deshalb wird
     ueber assets/byg-bike-index.json in die zeichengenaue Schreibweise des
     Filters uebersetzt. Gibt es das Modell dort nicht (gestrichen), kommt
     nichts in den neuen Speicher, und das aktive neue Bike wird
     zurueckgenommen, damit die Wahl des Kunden sichtbar gilt. */
  function insNeu(b) {
    holJson('byg-bike-index.json')
      .then(function (idx) {
        var ziel = schluessel(b.marke + b.modell), f = null;
        Object.keys(idx).forEach(function (m) {
          Object.keys(idx[m]).forEach(function (mo) { if (schluessel(m + mo) === ziel) f = m + ' ' + mo; });
        });
        var l;
        try { l = JSON.parse(window.localStorage.getItem(NEU)); } catch (e) { l = null; }
        if (!Array.isArray(l)) l = [];
        if (f) {
          l = l.filter(function (x) { return x && x.f !== f; });
          l.unshift({ f: f, jahr: b.jahr || null });
        } else if (l.length) {
          l.shift();
        }
        try { window.localStorage.setItem(NEU, JSON.stringify(l.slice(0, 3))); } catch (e) {}
        alleBadges(); zeichneLeiste();
      })
      .catch(function () {});
  }
  function ausNeuEntfernen() {
    try {
      var l = JSON.parse(window.localStorage.getItem(NEU));
      if (Array.isArray(l) && l.length) { l.shift(); window.localStorage.setItem(NEU, JSON.stringify(l)); }
    } catch (e) {}
  }

  function lies() {
    var n = ausNeu();
    if (n) return n;
    try {
      var r = window.localStorage.getItem(SCHLUESSEL);
      if (!r) return null;
      var b = JSON.parse(r);
      if (!b || !b.marke || !b.modell) return null;
      return b;
    } catch (e) { return null; }
  }
  function schreib(b) {
    try { window.localStorage.setItem(SCHLUESSEL, JSON.stringify(b)); } catch (e) {}
    insNeu(b);
    melde(b);
  }
  function loesche() {
    try { window.localStorage.removeItem(SCHLUESSEL); } catch (e) {}
    ausNeuEntfernen();
    melde(null);
  }
  function melde(b) {
    document.dispatchEvent(new CustomEvent('byg:garage', { detail: b }));
  }
  function name(b) {
    if (!b) return '';
    return b.marke + ' ' + b.modell + (b.jahr ? ' (' + b.jahr + ')' : '');
  }

  /* ---------- Passung am Produkt ----------
     Die Entscheidung faellt NICHT hier aus dem Index, sondern aus den
     Daten des Produkts selbst (data-byg-fitment). Der Index kennt nur
     die Auswahlliste; was ein einzelnes Teil kann, weiss nur das Teil.
     DREI FAELLE STATT ZWEI — der Unterschied ist nicht kosmetisch.
     Ein Teil, dessen Modell passt, kann beim Baujahr drei Zustaende haben:
       a) Jahr liegt in der Spanne            -> passt
       b) Jahr liegt NACHWEISLICH daneben     -> jahr-passt-nicht
       c) Jahr ist gar nicht hinterlegt       -> jahr-unbekannt
     Fall c sah in der ersten Fassung aus wie Fall b, und das war eine
     falsche Auskunft an den Kunden. Die Daten unterscheiden das sehr
     wohl: wo der Lieferant keine Jahre nennt, steht im Metafeld
       {"marke":"KTM","modell":"125 SX",
        "baujahre":"laut Lieferantendaten nicht angegeben"}
     also ein Text statt von/bis. Das ist bewusst so gepflegt und keine
     Schlamperei — es betrifft 1.768 der 3.850 aktiven Artikel, darunter
     fast alle Kunststoffteile, Kuehlerschutzgitter und Startnummern-
     tafeln. "Passt nicht fuer Baujahr 2019" zu sagen, wo in Wahrheit
     niemand das Baujahr kennt, haette Kunden von Teilen abgehalten, die
     mit grosser Wahrscheinlichkeit passen.
     Rueckgabe: 'passt' | 'jahr-unbekannt' | 'jahr-passt-nicht' |
                'passt-nicht' | null (= keine Aussage moeglich) */
  /* VERGLEICHSSCHLUESSEL. Dieselbe Maschine heisst an drei Stellen
     verschieden: im Fitment "GasGas", im Index "GASGAS", im Metafeld
     byg.modelle "GAS GAS MC 300". Ein roher Textvergleich scheitert
     daran. Der Schluessel wirft alles weg, was nicht Buchstabe oder
     Ziffer ist, und vergleicht in Grossbuchstaben:
       "GAS GAS MC 300" -> GASGASMC300
       "GASGAS" + "MC 300" -> GASGASMC300 */
  function schluessel(s) {
    return String(s == null ? '' : s).toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  /* EINHEITLICHE NAMEN (05.10.2026). byg.fitment ist das Rohfeld des
     Lieferanten und schreibt dieselbe Maschine verschieden: "250 EXC TPI",
     "125 SX TBI", "MX 125 Carb", "85 SX mit 105 Big Bore", "RACING MX 85"
     unter Marke TM Racing, "RR 250" fuer den Beta-Zweitakter. Der
     Bike-Waehler kennt nur die einheitlichen Namen. Ohne diese Tabelle
     bekam der 250-EXC-Fahrer beim TPI-Kolben "passt nicht" angezeigt.
     Die Tabelle ist dieselbe wie in passung/kanon.py (ALIAS + MEHRFACH),
     mit der byg.passung erzeugt wurde — beide Stellen muessen gleich
     bleiben. Schluessel und Ziele sind bereits durch schluessel() gelaufen. */
  var ALIAS = {
    GASGASMC250F: 'GASGASMC250F', GASGASMC350F: 'GASGASMC350F', GASGASMC450F: 'GASGASMC450F',
    BETARR250: 'BETARR2502T', BETARR300: 'BETARR3002T',
    KTM125SXTBI: 'KTM125SX', KTM150SXTBI: 'KTM150SX',
    KTM250EXCTPI: 'KTM250EXC', KTM300EXCTPI: 'KTM300EXC', KTM250EXCTBI: 'KTM250EXC',
    TMRACINGMX125CARB: 'TMRACINGMX125', TMRACINGMX125FI: 'TMRACINGMX125',
    TMRACINGMX250CARB: 'TMRACINGMX250', TMRACINGMX250FI: 'TMRACINGMX250',
    GASGASMC85MIT105BIGBORE: 'GASGASMC85', KTM85SXMIT105BIGBORE: 'KTM85SX',
    HUSQVARNATC85MIT105BIGBORE: 'HUSQVARNATC85'
  };
  var MEHRFACH = { DUCATIDESMO450: ['DUCATIDESMO450EDS', 'DUCATIDESMO450MX'] };
  function kanonSchluessel(s) {
    var k = schluessel(s).replace(/^TMRACINGRACING/, 'TMRACING');
    if (MEHRFACH[k]) return MEHRFACH[k];
    return [ALIAS[k] || k];
  }

  /* Modell bekannt, Baujahre nicht: 252 Artikel haben byg.modelle ohne
     byg.fitment. Vorher sagte das Badge dort "keine Modellzuordnung
     hinterlegt" — falsch, denn das Modell steht da. Jetzt wird es
     geprueft und, wenn es passt, als Treffer ohne Jahresangabe
     gemeldet. */
  function pruefeModelle(modelle, bike) {
    if (!bike || !Array.isArray(modelle) || !modelle.length) return null;
    var meins = schluessel(bike.marke + bike.modell);
    for (var i = 0; i < modelle.length; i++) {
      if (kanonSchluessel(modelle[i]).indexOf(meins) > -1) return 'jahr-unbekannt';
    }
    return 'passt-nicht';
  }

  function pruefe(fitment, bike) {
    if (!bike || !Array.isArray(fitment) || !fitment.length) return null;
    var ohneJahr = false, jahrDaneben = false;
    for (var i = 0; i < fitment.length; i++) {
      var f = fitment[i];
      /* Manche Lieferanten schreiben die Marke ins Modell
         ({"modell":"GAS GAS EC 250"}) und lassen marke weg. Solche
         Eintraege wurden frueher uebersprungen — mit "passt nicht" als
         Ergebnis, obwohl das Teil passte. */
      if (!f || !f.modell) continue;
      if (kanonSchluessel((f.marke || '') + f.modell).indexOf(schluessel(bike.marke + bike.modell)) < 0) continue;
      /* Marke und Modell stimmen. Ohne gewaehltes Baujahr ist das schon
         die Antwort; mit Baujahr muss es in die Spanne fallen. */
      if (!bike.jahr) return 'passt';
      var von = parseInt(f.von, 10), bis = parseInt(f.bis, 10);
      if (!von || !bis) { ohneJahr = true; continue; }
      if (bike.jahr >= von && bike.jahr <= bis) return 'passt';
      jahrDaneben = true;
    }
    /* Reihenfolge zaehlt: ein Eintrag OHNE Jahresangabe schlaegt einen
       Eintrag mit danebenliegendem Jahr. Wer beides hat, soll die
       mildere und ehrlichere Auskunft bekommen. */
    if (ohneJahr) return 'jahr-unbekannt';
    if (jahrDaneben) return 'jahr-passt-nicht';
    return 'passt-nicht';
  }

  /* ---------- EINE STELLE, DIE DIE DREI FORMEN KENNT ----------
     Der Datenblock auf der Kollektionsseite reicht pro Artikel eine von
     drei Formen herein:
         [ {marke,modell,von,bis}, ... ]   echte Passung
         "universal"                       modellunabhaengig
         { "m": ["KTM 125 SX", ...] }      Modell bekannt, Baujahr nicht

     WARUM DAS HIER STEHT UND NICHT ZWEIMAL VERTEILT:
     Die dritte Form kam spaeter dazu. Sie wurde im Datenblock erzeugt und
     im Produkt-Badge ausgewertet — aber NICHT in der Leiste. Dort lief
     sie in pruefe(), das ein Array erwartet, bekam null zurueck und
     landete im else-Zweig: "passt nicht". Auf /collections/kolben waren
     damit 14 von 24 Artikeln falsch markiert, darunter der Woessner
     Kolbenkit 8327, der auf die Husqvarna TC 300 TATSAECHLICH passt.
     Einem Kunden das richtige Teil als falsch anzuzeigen ist schlimmer
     als gar keine Markierung. Deshalb gibt es jetzt genau eine Funktion,
     die die Formen auseinanderhaelt; wer eine vierte ergaenzt, ergaenzt
     sie hier und ist in allen Aufrufern fertig. */
  function pruefeEintrag(fit, bike) {
    if (!fit || !bike) return null;
    if (fit === 'universal') return 'universal';
    if (Array.isArray(fit)) return pruefe(fit, bike);
    if (fit.m) return pruefeModelle(fit.m, bike);
    return null;
  }

  function zeichneBadge(el) {
    /* Drei Sorten Produkt, drei Aussagen:
         data-byg-passung="universal"  -> passt immer
         data-byg-passung="unbekannt"  -> keine Modellzuordnung hinterlegt
         data-byg-fitment="[...]"      -> echte Passung, wird geprueft
       Frueher schwieg das Badge in den ersten beiden Faellen. Das war
       unbefriedigend: wer nichts liest, weiss nicht, ob er etwas
       uebersehen hat. */
    var sorte = el.getAttribute('data-byg-passung');
    if (sorte === 'universal') {
      /* EHRLICH STATT "PASST UEBERALL" (15.10.2026, Abschlusspruefung).
         Hier stand "Universalteil — modellunabhaengig einsetzbar", auch
         beim 2-Takt-Mischoel: fuer einen Viertakter ist das falsch. Die
         Bike-Uebersicht sagt zu denselben Teilen "Bei Oelen gilt die
         Spezifikation aus dem Handbuch". Jetzt dieselbe Aussage: nicht
         an ein Modell gebunden, aber die Spezifikation zaehlt. Nennt der
         Produkttitel eindeutig 2T oder 4T, steht der Motortyp dabei. */
      var tt = '';
      var h1 = (el.closest('.product, product-info, .product__info-wrapper, main') || document).querySelector('h1');
      if (h1) tt = h1.textContent || '';
      var zwei = /\b2T\b|2-Takt|Zweitakt/i.test(tt), vier = /\b4T\b|4-Takt|Viertakt/i.test(tt);
      var satz = zwei && !vier ? '<strong>Für 2-Takt-Motoren</strong>, nicht an ein Modell gebunden — Spezifikation laut Handbuch deines Bikes prüfen.'
        : vier && !zwei ? '<strong>Für 4-Takt-Motoren</strong>, nicht an ein Modell gebunden — Spezifikation laut Handbuch deines Bikes prüfen.'
        : '<strong>Nicht modellgebunden</strong> — bei Ölen und Flüssigkeiten gilt die Spezifikation aus dem Handbuch deines Bikes.';
      el.hidden = false;
      el.className = 'byg-garage-badge byg-garage-badge--universal';
      el.innerHTML = '<span class="byg-garage-badge__zeichen" aria-hidden="true"></span>' +
        '<span class="byg-garage-badge__text">' + satz + '</span>';
      return;
    }
    if (sorte === 'unbekannt') {
      el.hidden = false;
      el.className = 'byg-garage-badge byg-garage-badge--offen';
      el.innerHTML = '<span class="byg-garage-badge__zeichen" aria-hidden="true"></span>' +
        '<span class="byg-garage-badge__text">Für dieses Teil ist keine Modellzuordnung hinterlegt. ' +
        'Schreib uns Marke, Modell und Baujahr — wir prüfen es vor der Bestellung.</span>';
      return;
    }

    /* Rueckfall: Modell bekannt, Baujahre nicht. */
    var rohModelle = el.getAttribute('data-byg-modelle');
    if (rohModelle) {
      var modelle = [];
      try { modelle = JSON.parse(rohModelle); } catch (e) { modelle = []; }
      var bikeM = lies();
      el.hidden = false;
      if (!bikeM) { leerBadge(el); return; }
      var zm = pruefeModelle(modelle, bikeM);
      if (zm === 'jahr-unbekannt') {
        el.className = 'byg-garage-badge byg-garage-badge--offen';
        el.innerHTML = zeichen() +
          '<span class="byg-garage-badge__text">Laut Hersteller gelistet für die <strong>' + text(bikeM.marke + ' ' + bikeM.modell) +
          '</strong>. Für welche Baujahre, ist nicht hinterlegt — bei Unsicherheit kurz fragen.</span>' + aendern();
      } else {
        el.className = 'byg-garage-badge byg-garage-badge--nicht';
        el.innerHTML = zeichen() +
          '<span class="byg-garage-badge__text">Für deine <strong>' + text(name(bikeM)) +
          '</strong> nicht gelistet. Hinterlegt ist: ' + text(modelle.slice(0, 4).join(', ')) +
          (modelle.length > 4 ? ' …' : '') + '</span>' + aendern();
      }
      return;
    }

    var fitment;
    try { fitment = JSON.parse(el.getAttribute('data-byg-fitment') || '[]'); }
    catch (e) { fitment = []; }
    if (!fitment.length) { el.hidden = true; return; }

    var bike = lies();
    var zustand = pruefe(fitment, bike);
    el.hidden = false;
    el.classList.remove('byg-garage-badge--passt', 'byg-garage-badge--nicht', 'byg-garage-badge--jahr', 'byg-garage-badge--offen', 'byg-garage-badge--leer');

    /* Eine Stelle, die den Leer-Zustand malt — vorher stand derselbe
       Aufruf hier noch ein zweites Mal ausgeschrieben. */
    if (!bike) { leerBadge(el); return; }
    var wen = name(bike);
    if (zustand === 'passt') {
      el.classList.add('byg-garage-badge--passt');
      el.innerHTML = '<span class="byg-garage-badge__zeichen" aria-hidden="true"></span>' +
        '<span class="byg-garage-badge__text">Laut Hersteller gelistet für deine <strong>' + text(wen) + '</strong></span>' +
        '<button type="button" class="byg-garage-badge__wechseln" data-byg-garage-oeffnen>ändern</button>';
    } else if (zustand === 'jahr-unbekannt') {
      el.classList.add('byg-garage-badge--offen');
      el.innerHTML = '<span class="byg-garage-badge__zeichen" aria-hidden="true"></span>' +
        '<span class="byg-garage-badge__text">Laut Hersteller gelistet für die <strong>' + text(bike.marke + ' ' + bike.modell) +
        '</strong>. Für welche Baujahre, gibt der Hersteller nicht an — ' +
        'bei Unsicherheit kurz fragen, wir prüfen es vor der Bestellung.</span>' +
        '<button type="button" class="byg-garage-badge__wechseln" data-byg-garage-oeffnen>ändern</button>';
    } else if (zustand === 'jahr-passt-nicht') {
      el.classList.add('byg-garage-badge--jahr');
      el.innerHTML = '<span class="byg-garage-badge__zeichen" aria-hidden="true"></span>' +
        '<span class="byg-garage-badge__text">Laut Hersteller für die <strong>' + text(bike.marke + ' ' + bike.modell) +
        '</strong> gelistet, aber nicht für Baujahr <strong>' + text(String(bike.jahr)) + '</strong>. ' +
        'Frag uns kurz, bevor du bestellst.</span>' +
        '<button type="button" class="byg-garage-badge__wechseln" data-byg-garage-oeffnen>ändern</button>';
    } else {
      el.classList.add('byg-garage-badge--nicht');
      el.innerHTML = '<span class="byg-garage-badge__zeichen" aria-hidden="true"></span>' +
        '<span class="byg-garage-badge__text">Für deine <strong>' + text(wen) + '</strong> nicht gelistet</span>' +
        '<button type="button" class="byg-garage-badge__wechseln" data-byg-garage-oeffnen>ändern</button>';
    }
  }
  function zeichen() { return '<span class="byg-garage-badge__zeichen" aria-hidden="true"></span>'; }
  function aendern() {
    return '<button type="button" class="byg-garage-badge__wechseln" data-byg-garage-oeffnen>ändern</button>';
  }
  function leerBadge(el) {
    /* DIE KLASSENLISTE GANZ SETZEN, NICHT NUR ERGAENZEN.
       Hier stand classList.add. Wer auf einer offenen Seite die Garage
       leert, hatte dann "byg-garage-badge--nicht byg-garage-badge--leer"
       am Element stehen: der neutrale Aufruf "Passt das auf dein Bike?"
       erschien in der Optik von "passt nicht" — dunkle Flaeche, weisse
       Schrift. Am Objekt gesehen auf
       /products/wossner-kolben-husqvarna-tc-300, nachdem das Bike
       entfernt wurde. Beim Neuladen der Seite faellt es nicht auf, weil
       dann noch keine Zustandsklasse am Element haengt — genau die Sorte
       Fehler, die eine Pruefung ohne Zustandswechsel durchlaesst. */
    el.hidden = false;
    el.className = 'byg-garage-badge byg-garage-badge--leer';
    el.innerHTML = '<button type="button" class="byg-garage-badge__ruf" data-byg-garage-oeffnen>' +
      'Für dein Bike gelistet? Bike wählen</button>';
  }

  function text(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function alleBadges() {
    /* AN DER KLASSE SAMMELN, NICHT AN DEN ATTRIBUTEN.
       Dieser Selektor ist zweimal hintereinander zur Fehlerquelle
       geworden. Zuerst stand hier nur [data-byg-fitment] — Universalteile
       tragen aber data-byg-passung und blieben leer (gefunden an
       /products/motorex-moto-clean-plus). Danach kam data-byg-modelle als
       dritte Form hinzu, und derselbe Fehler war wieder da: das Badge auf
       /products/wossner-kolben-husqvarna-tc-300 blieb stumm, weil der
       Selektor die neue Form nicht kannte.
       Die Klasse byg-garage-badge tragen ALLE drei Formen (siehe
       snippets/byg-fitment.liquid, Zeile 112/114/177). Wer dort eine
       vierte Form ergaenzt, wird hier automatisch mitgenommen. Die
       Attributselektoren bleiben als Netz stehen, falls ein Badge einmal
       ohne die Klasse gesetzt wird; querySelectorAll liefert jedes
       Element nur einmal, es wird also nichts doppelt gezeichnet. */
    var l = document.querySelectorAll(
      '.byg-garage-badge, [data-byg-fitment], [data-byg-passung], [data-byg-modelle]'
    );
    for (var i = 0; i < l.length; i++) zeichneBadge(l[i]);
  }

  /* ---------- Der Waehler ----------
     INDEXPFAD AUS DEM EIGENEN SKRIPT ABLEITEN.
     Auf der Startseite reicht die Section das Ziel als Attribut herein.
     Auf einer Produktseite gibt es die Section nicht — und genau dort
     braucht man den Waehler am dringendsten: wer ueber Google auf einem
     Kolben landet, soll sein Bike dort setzen koennen und nicht erst
     zur Startseite fahren muessen.
     Der Pfad steht im src dieses Skripts; daraus wird der Dateiname
     getauscht. Die ?v=-Fassung wird abgeschnitten, weil sie je Datei
     verschieden ist — geladen wird trotzdem nicht die nackte Adresse,
     sondern ueber adressen()/holJson() unten (15.10.2026). */
  function indexPfad() {
    var sc = document.querySelector('script[src*="byg-garage.js"]');
    if (!sc) return null;
    return sc.getAttribute('src').split('?')[0].replace('byg-garage.js', 'byg-garage-index.json');
  }

  /* FRISCHE DATEN (15.10.2026). Die nackte Adresse ohne ?v= liefert das
     CDN bis zu ein Jahr aus dem Zwischenspeicher (cache-control
     max-age=31557600). Gemessen: byg-modell-kollektion.json ohne ?v trug
     Stunden nach der Korrektur noch "BETA RX 350 2T" -> beta-rx-450-4t,
     die ?v=-Fassung des Hero nicht mehr. Reihenfolge deshalb:
     1. die versionierte Adresse (asset_url), wenn eine Section sie ins
        HTML schreibt — als Attribut am Skript-Tag (data-modell-kollektion,
        data-garage-index, data-bike-index) oder an einem anderen Element
        (Hero: data-kollektionen, data-index; Bike-Waehler: data-index);
     2. die nackte Adresse mit einer Stunden-Marke als ?v= — eine
        Aenderung kommt so spaetestens nach einer Stunde an;
     3. die nackte Adresse (nur, wenn das CDN fuer eine neue Marke einen
        Fehler liefert; bei neuen ?v=-Werten gelegentlich 502 gemessen). */
  function adressen(datei) {
    var l = [];
    var kandidaten = document.querySelectorAll('script[src*="byg-garage.js"], [data-kollektionen], [data-index], [data-byg-garage-index]');
    for (var i = 0; i < kandidaten.length && !l.length; i++) {
      var at = kandidaten[i].attributes;
      for (var j = 0; j < at.length; j++) {
        if (at[j].name !== 'src' && at[j].value.indexOf('/' + datei + '?v=') > -1) { l.push(at[j].value); break; }
      }
    }
    var p = indexPfad();
    if (p) {
      var nackt = p.replace('byg-garage-index.json', datei);
      l.push(nackt + '?v=byg' + Math.floor(Date.now() / 36e5), nackt);
    }
    return l;
  }
  function holJson(datei) {
    var l = adressen(datei), i = 0;
    if (!l.length || !window.fetch) return Promise.reject(new Error('kein Pfad'));
    function versuch() {
      return fetch(l[i], { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .catch(function (e) { i++; if (i < l.length) return versuch(); throw e; });
    }
    return versuch();
  }

  var INDEX = null, laedt = null;
  function holIndex() {
    if (INDEX) return Promise.resolve(INDEX);
    if (laedt) return laedt;
    laedt = holJson('byg-garage-index.json')
      .then(function (j) { INDEX = j; return j; })
      .catch(function (e) { laedt = null; throw e; });
    return laedt;
  }

  function baueWaehler(wurzel) {
    var sMarke  = wurzel.querySelector('[data-byg-marke]');
    var sModell = wurzel.querySelector('[data-byg-modell]');
    var sJahr   = wurzel.querySelector('[data-byg-jahr]');
    var merken  = wurzel.querySelector('[data-byg-merken]');
    var raus    = wurzel.querySelector('[data-byg-loeschen]');
    var stand   = wurzel.querySelector('[data-byg-stand]');
    if (!sMarke || !sModell || !sJahr) return;

    function fuelle(sel, werte, platzhalter) {
      sel.innerHTML = '';
      var o = document.createElement('option');
      o.value = ''; o.textContent = platzhalter;
      sel.appendChild(o);
      werte.forEach(function (w) {
        var x = document.createElement('option');
        x.value = String(w); x.textContent = String(w);
        sel.appendChild(x);
      });
    }

    function zeigeStand() {
      var b = lies();
      if (!stand) return;
      if (b) {
        stand.hidden = false;
        stand.querySelector('[data-byg-stand-name]').textContent = name(b);
      } else {
        stand.hidden = true;
      }
      if (raus) raus.hidden = !b;
    }

    holIndex().then(function (idx) {
      fuelle(sMarke, Object.keys(idx).sort(), 'Marke wählen');
      sMarke.disabled = false;

      var b = lies();
      if (b && idx[b.marke]) {
        sMarke.value = b.marke;
        fuelle(sModell, Object.keys(idx[b.marke]).sort(), 'Modell wählen');
        sModell.disabled = false;
        if (idx[b.marke][b.modell]) {
          sModell.value = b.modell;
          fuelle(sJahr, idx[b.marke][b.modell].slice().reverse(), 'Baujahr (optional)');
          sJahr.disabled = false;
          if (b.jahr) sJahr.value = String(b.jahr);
        }
      }
      zeigeStand();

      sMarke.addEventListener('change', function () {
        var m = sMarke.value;
        if (m && idx[m]) {
          fuelle(sModell, Object.keys(idx[m]).sort(), 'Modell wählen');
          sModell.disabled = false;
        } else {
          fuelle(sModell, [], 'Modell wählen'); sModell.disabled = true;
        }
        fuelle(sJahr, [], 'Baujahr (optional)'); sJahr.disabled = true;
      });

      sModell.addEventListener('change', function () {
        var m = sMarke.value, mo = sModell.value;
        var jahre = (m && mo && idx[m] && idx[m][mo]) ? idx[m][mo] : [];
        fuelle(sJahr, jahre.slice().reverse(), jahre.length ? 'Baujahr (optional)' : 'kein Baujahr hinterlegt');
        sJahr.disabled = !jahre.length;
      });
    }).catch(function () {
      /* Index nicht ladbar: Waehler ausblenden statt kaputt stehen lassen. */
      wurzel.hidden = true;
    });

    if (merken) merken.addEventListener('click', function () {
      if (!sMarke.value || !sModell.value) return;
      schreib({ marke: sMarke.value, modell: sModell.value, jahr: sJahr.value ? parseInt(sJahr.value, 10) : null });
      zeigeStand();
    });
    if (raus) raus.addEventListener('click', function () {
      loesche();
      sMarke.value = ''; fuelle(sModell, [], 'Modell wählen'); sModell.disabled = true;
      fuelle(sJahr, [], 'Baujahr (optional)'); sJahr.disabled = true;
      zeigeStand();
    });
  }

  /* ============================================================
     DIE KOLLEKTIONSSEITE

     Hier beantwortet die Garage die Frage, die Manuel gestellt hat:
     "KTM -> 125 SX -> dann erscheinen alle Produkte, aber keine
     BJ-Filtermoeglichkeit."

     ZWEI WEGE, UND DAS SKRIPT WAEHLT SELBST:

     a) Shopify filtert selbst. Dann steht im Filterformular ein Feld
        namens filter.p.m.byg.modelle. In dem Fall bietet die Leiste
        einen Knopf an, der GENAU DAS tut — serverseitig, ueber alle
        Blaetter, mit richtigen Zahlen.
     b) Shopify filtert nicht. Dann markiert die Leiste die Karten
        DIESER Seite und sagt ausdruecklich "auf dieser Seite".

     WARUM DIE PRUEFUNG UND NICHT EINFACH DER LINK:
     Shopify ignoriert einen Filterparameter, den es nicht kennt, und
     liefert die ungefilterte Seite aus — ohne Fehler, ohne Hinweis.
     Ein fest eingebauter Link wuerde dem Kunden also den ganzen Katalog
     zeigen und behaupten, es seien die Teile fuer sein Bike. Nachgeprueft
     am Objekt: /collections/all/bike:gibtsnicht-999-xx liefert 161 Seiten.
     Deshalb wird der Knopf nur gezeigt, wenn der Filter nachweislich da
     ist — und erscheint von allein, sobald er freigeschaltet wird.
     ============================================================ */

  function passungsKarte() {
    var el = document.querySelector('script[data-byg-passung]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* Die Karte gehoert zum Produkt, auf das ihr Link zeigt. Das Markup der
     Karte selbst bleibt unberuehrt (sie kommt aus dem Basis-Theme). */
  function kartenMitHandle() {
    var raus = [];
    var li = document.querySelectorAll('#data-pagination > li, .product-grid > li');
    for (var i = 0; i < li.length; i++) {
      var a = li[i].querySelector('a[href*="/products/"]');
      if (!a) continue;
      var m = a.getAttribute('href').match(/\/products\/([^?#\/]+)/);
      if (m) raus.push({ el: li[i], handle: m[1] });
    }
    return raus;
  }

  function modellFilterVerfuegbar() {
    return !!document.querySelector('[name^="filter.p.m.byg.modelle"]');
  }

  function filterUrl(bike) {
    var u = new URL(window.location.href);
    u.searchParams.delete('page');
    u.searchParams.set('filter.p.m.byg.modelle', bike.marke + ' ' + bike.modell);
    return u.pathname + u.search;
  }

  /* BIKE-FILTER AUTOMATISCH (Manuel, 05.10.2026). Wer ein Bike gewaehlt hat
     und eine ungefilterte Kollektion oeffnet, sah bisher z. B. 3 von 24
     Karten, der Rest war ausgeblendet, und "Mehr anzeigen" brachte je
     zwei, drei dazu. Jetzt wird der Shopify-Filter fuer das Modell
     gesetzt, ueber alle Blaetter. Bedingungen:
     - Shopify bietet den Modellfilter auf dieser Seite an (sonst kaeme
       der ganze Katalog, siehe Block oben);
     - auf dieser Seite waeren mehr Karten ausgeblendet als sichtbar
       (Oele & Pflege u. Ae. bleiben so unberuehrt);
     - hoechstens EINMAL pro Sitzung, Bike und Kollektion: wer den Filter
       an der Pille loescht, bekommt das ganze Sortiment und behaelt es.
     Angebot, keine Schranke. */
  function autoKey(bike) {
    return 'byg-auto:' + bike.marke + ' ' + bike.modell + ':' + window.location.pathname;
  }
  /* Der Kunde hat den automatisch gesetzten Filter wieder geloescht:
     dann will er das ganze Sortiment sehen — ohne Ausblenden und ohne
     Abdunkeln (Manuel: nie ausgrauen). Gelistete Teile behalten ihren
     lila Strich, der Rest steht normal da. */
  function alleGewollt(bike) {
    if (new URLSearchParams(window.location.search).has('filter.p.m.byg.modelle')) return false;
    try { return !!window.sessionStorage.getItem(autoKey(bike)); } catch (e) { return false; }
  }

  /* FREMDE MARKE, TEILEMARKE (15.10.2026). Mit gemerkter KTM 250 SX hing
     auf /collections/yamaha, /collections/beta und /collections/metzeler
     automatisch filter.p.m.byg.modelle=KTM+250+SX an der Adresse: dort
     passt fast nichts zur KTM, also waren "mehr Karten ausgeblendet als
     sichtbar" — genau die Bedingung fuer den Automatik-Filter. Wer
     bewusst eine andere Bike-Marke oder die Kollektion einer Teilemarke
     oeffnet, will deren Sortiment sehen. Dort gilt deshalb: kein
     automatischer Filter und nichts ausblenden (sonst bliebe die Seite
     fast leer); passende Teile behalten ihren lila Strich, und der Knopf
     "Nur Teile für mein Bike" bleibt als Angebot in der Leiste.
     - Bike-Marke: der Anfang der Adresse ist eine Marke aus dem Waehler
       (/collections/yamaha, /collections/yamaha-yz-250, /collections/tm,
       /collections/tm-racing-mx-85), aber nicht die des gemerkten Bikes.
     - Teilemarke: Shopify bietet im Filter "Marke" (filter.p.vendor) nur
       EINEN Hersteller an, und die Adresse beginnt mit dessen Namen
       (/collections/metzeler, /collections/twin-air, /collections/wossner).
       Eine Sachkollektion mit nur einem Hersteller (z. B. Engine Tuning)
       bleibt so unberuehrt. */
  var BIKEMARKEN = ['BETA', 'DUCATI', 'FANTIC', 'GASGAS', 'HONDA', 'HUSABERG', 'HUSQVARNA',
    'KAWASAKI', 'KTM', 'SHERCO', 'SUZUKI', 'TMRACING', 'TRIUMPH', 'YAMAHA'];
  var MARKE_KURZ = { TM: 'TMRACING' };
  /* Wie schluessel(), nur ohne Umlaut-Verlust: "Wössner" -> WOSSNER. */
  function grob(s) {
    s = String(s == null ? '' : s);
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return schluessel(s);
  }
  function seitenHandle() {
    var m = window.location.pathname.match(/^\/collections\/([^\/?#]+)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }
  function bikeMarkeDerSeite() {
    var teile = seitenHandle().split('-');
    var marken = BIKEMARKEN.slice();
    if (INDEX) Object.keys(INDEX).forEach(function (k) { k = schluessel(k); if (marken.indexOf(k) < 0) marken.push(k); });
    for (var n = Math.min(2, teile.length); n >= 1; n--) {
      var k = grob(teile.slice(0, n).join(''));
      k = MARKE_KURZ[k] || k;
      if (k && marken.indexOf(k) > -1) return k;
    }
    return null;
  }
  function teilemarkeDerSeite() {
    var el = document.querySelectorAll('input[name="filter.p.vendor"]'), werte = [];
    for (var i = 0; i < el.length; i++) if (werte.indexOf(el[i].value) < 0) werte.push(el[i].value);
    if (werte.length !== 1) return null;
    var v = grob(werte[0]);
    return v && grob(seitenHandle()).indexOf(v) === 0 ? werte[0] : null;
  }
  function fremdeSeite(bike) {
    if (!/^\/collections\//.test(window.location.pathname)) return false;
    var m = bikeMarkeDerSeite();
    if (m) return m !== schluessel(bike.marke);
    return !!teilemarkeDerSeite();
  }

  function autoFilter(bike, nicht, treffer) {
    if (!modellFilterVerfuegbar()) return false;
    if (!/^\/collections\//.test(window.location.pathname)) return false;
    if (fremdeSeite(bike)) return false;
    if (new URLSearchParams(window.location.search).has('filter.p.m.byg.modelle')) return false;
    if (nicht < 3 || nicht <= treffer) return false;
    var key = autoKey(bike);
    try {
      if (window.sessionStorage.getItem(key)) return false;
      window.sessionStorage.setItem(key, '1');
    } catch (e) { return false; }
    window.location.replace(filterUrl(bike));
    return true;
  }

  /* MODELLSEITE ERKENNEN (15.10.2026). Auf /collections/ktm-250-sx
     fragte die leere Leiste "Du suchst Teile fuer ein bestimmtes Bike?",
     obwohl die Seite schon das Bike ist. assets/byg-modell-kollektion.json
     (dieselbe Tabelle wie im Hero) sagt, welches Modell zu welcher
     Kollektion gehoert. Nur wenn genau EIN Modell auf die Kollektion
     zeigt, gilt sie als Modellseite. */
  var MODELLKOLL = null, mkLaedt = null;
  function holModellKollektionen() {
    if (mkLaedt) return mkLaedt;
    mkLaedt = holJson('byg-modell-kollektion.json')
      .catch(function () { return {}; })
      .then(function (j) { MODELLKOLL = j || {}; return MODELLKOLL; });
    return mkLaedt;
  }
  function modellDerSeite() {
    var m = window.location.pathname.match(/^\/collections\/([^\/?#]+)/);
    if (!m || !MODELLKOLL) return null;
    var h = decodeURIComponent(m[1]), treffer = [];
    Object.keys(MODELLKOLL).forEach(function (f) { if (MODELLKOLL[f] === h) treffer.push(f); });
    return treffer.length === 1 ? treffer[0] : null;
  }
  /* MODELLKOLLEKTION STATT /collections/all (23.10.2026, Fitment-Sitzung).
     /collections/all hat seit 22.10.2026 mehr als 5.000 aktive Artikel.
     Shopify wendet dort keine Filter mehr an, die Liste kam ungefiltert,
     und die Bike-Uebersicht zeigte Teile fremder Modelle. Links mit
     Bike-Filter gehen deshalb auf die Modellkollektion des Bikes aus
     byg-modell-kollektion.json (ist beim Zeichnen der Leiste geladen,
     siehe holModellKollektionen().then(zeichneLeiste)). */
  function modellBasis(bike) {
    var h = (MODELLKOLL && bike) ? MODELLKOLL[bike.marke + ' ' + bike.modell] : null;
    return '/collections/' + (h ? encodeURIComponent(h) : 'all');
  }
  /* Ist diese Kollektion die Modellseite des gemerkten Bikes? (15.10.2026) */
  function eigeneModellseite(bike) {
    if (!bike || !MODELLKOLL) return false;
    var h = MODELLKOLL[bike.marke + ' ' + bike.modell];
    return !!h && h === seitenHandle();
  }
  /* Adresse ohne Modellfilter, aber nur, wenn ein Modellfilter in der
     Adresse steht, den Shopify nicht als Auswahl zeigt (keine Pille,
     kein angehaktes Feld). Sonst null. (15.10.2026) */
  function ganzesSortimentUrl() {
    if (!/^\/collections\//.test(window.location.pathname)) return null;
    var u = new URL(window.location.href);
    var werte = u.searchParams.getAll('filter.p.m.byg.modelle');
    if (!werte.length) return null;
    var an = {};
    var felder = document.querySelectorAll('input[name="filter.p.m.byg.modelle"]');
    for (var i = 0; i < felder.length; i++) if (felder[i].checked) an[felder[i].value] = 1;
    var unsichtbar = werte.some(function (v) { return !an[v]; });
    if (!unsichtbar) return null;
    u.searchParams.delete('filter.p.m.byg.modelle');
    u.searchParams.delete('page');
    return u.pathname + u.search;
  }

  function zeichneLeiste() {
    var leiste = document.querySelector('[data-byg-garage-leiste]');
    if (!leiste) return;
    var karte = passungsKarte();
    var bike = lies();

    if (!bike) {
      if (!MODELLKOLL && /^\/collections\//.test(window.location.pathname)) {
        leiste.hidden = true;
        holModellKollektionen().then(zeichneLeiste);
        return;
      }
      var modell = modellDerSeite();
      leiste.hidden = false;
      leiste.className = 'byg-garage-leiste byg-garage-leiste--leer';
      if (modell) {
        leiste.innerHTML = '<span class="byg-garage-leiste__text">Dein Bike? ' +
          '<button type="button" class="byg-garage-leiste__link byg-garage-leiste__merken" data-byg-modell-merken="' + text(modell) + '">' +
          text(modell) + ' in der Garage merken</button></span>';
        return;
      }
      leiste.innerHTML = '<span class="byg-garage-leiste__text">Du suchst Teile für ein bestimmtes Bike? ' +
        '<a class="byg-garage-leiste__link" href="/#bike">Bike in deiner Garage wählen</a>, dann zeigen wir nur, was dafür gelistet ist.</span>';
      return;
    }
    if (!karte) { leiste.hidden = true; return; }

    var karten = kartenMitHandle();
    /* NUR PASSENDES ZEIGEN (Manuel, 05.10.2026): Ist ein Bike gewaehlt,
       werden unpassende Karten ausgeblendet statt ausgegraut — die
       vorhandene Regel body.byg-nur-passende in byg-garage.css. */
    /* Auf fremden Marken- und Teilemarken-Seiten (15.10.2026, siehe
       fremdeSeite) bleibt das ganze Sortiment stehen. */
    var alle = alleGewollt(bike) || fremdeSeite(bike);
    document.body.classList.toggle('byg-nur-passende', !alle);
    var passend = 0, offen = 0, nicht = 0, ohneAussage = 0, universal = 0;
    for (var i = 0; i < karten.length; i++) {
      var k = karten[i];
      var fit = karte[k.handle];
      k.el.classList.remove('byg-karte--passt', 'byg-karte--offen', 'byg-karte--nicht', 'byg-karte--universal');
      if (!fit) { ohneAussage++; continue; }
      var z = pruefeEintrag(fit, bike);
      if (z === 'universal') { universal++; k.el.classList.add('byg-karte--universal'); }
      else if (z === 'passt') { passend++; k.el.classList.add('byg-karte--passt'); }
      else if (z === 'jahr-unbekannt') { offen++; k.el.classList.add('byg-karte--offen'); }
      else if (z === null) { ohneAussage++; }
      else { nicht++; if (!alle) k.el.classList.add('byg-karte--nicht'); }
    }

    /* Ausgeblendete (passt nicht) zaehlen nicht mit — sie sind nicht zu sehen. */
    var gesamt = karten.length - (alle ? 0 : nicht);
    /* UNIVERSALTEILE ZAEHLEN ALS TREFFER. Hier stand treffer = passend +
       offen, und auf /collections/oele-pflege las die Leiste dann
       "0 von 24 auf dieser Seite passen, dazu 24 Universalteile" —
       obwohl auf dieser Seite JEDES Teil auf jedes Motorrad passt. Wer
       nur die erste Zahl liest, geht wieder. Oel passt, also wird es
       mitgezaehlt; die Modellunabhaengigkeit steht als Zusatz dabei. */
    var treffer = passend + offen + universal;
    if (autoFilter(bike, nicht, treffer)) return;
    /* 30.10.2026: byg-raster-voll.js fuellt die Seite auf, sobald alle Karten
       bewertet sind (nicht, wenn der Automatik-Filter die Seite gerade wechselt). */
    try { document.dispatchEvent(new CustomEvent('byg:karten', { detail: { n: karten.length, sichtbar: karten.length - (alle ? 0 : nicht) } })); } catch (e) {}
    /* Modell-Tabelle auch MIT Bike laden (15.10.2026, Abschlusspruefung):
       nur so erkennt die Leiste die Modellseite des eigenen Bikes (s. u.).
       Bis die Tabelle da ist, bleibt die Leiste verborgen — kein Knopf,
       der kurz aufblitzt und wieder verschwindet. Der Automatik-Filter
       oben wartet darauf nicht. */
    if (!MODELLKOLL && /^\/collections\//.test(window.location.pathname)) {
      leiste.hidden = true;
      holModellKollektionen().then(zeichneLeiste);
      return;
    }
    leiste.hidden = false;
    leiste.className = 'byg-garage-leiste';

    /* MEIN BIKE + ENTFERNEN (Manuel, 05.10.2026): "Beim Motorradfilter
       koennte man noch dazu schreiben: Mein Bike, und rechts einen Button
       Bike entfernen." Die Zeile sagt jetzt, wessen Bike das ist, und
       bietet den Ausstieg direkt daneben an — vorher ging das nur ueber
       "Bike aendern" auf der Startseite. */
    var kopf = '<div class="byg-garage-leiste__kopf">' +
      '<span class="byg-garage-leiste__label">Mein Bike</span>' +
      '<span class="byg-garage-leiste__bike">' + text(name(bike)) + '</span>' +
      '<button type="button" class="byg-garage-leiste__entfernen" data-byg-bike-entfernen>' +
      '<span><b aria-hidden="true">&times;</b>Bike entfernen</span></button>' +
      '</div>' +
      /* EHRLICHE ZAHL (15.10.2026): gezaehlt werden nur die Karten, die
         gerade geladen sind — die Zahl klang wie die Gesamtzahl fuer das
         Bike. */
      '<span class="byg-garage-leiste__zahl">Auf dieser Seite: ' + treffer +
      (treffer === 1 ? ' Teil laut Hersteller gelistet' : ' Teile laut Hersteller gelistet') +
      (universal === 0 ? ''
        : universal === treffer ? (treffer === 1 ? ' — modellunabhängig' : ' — alle modellunabhängig')
        : ' (' + universal + ' davon modellunabhängig)') +
      (nicht > 0 ? (alle ? ' · ganzes Sortiment wird angezeigt' : ' · ' + nicht + ' unpassende ausgeblendet') : '') +
      '</span>';

    var tat = '';
    if (treffer === 0 && modellFilterVerfuegbar()) {
      /* SACKGASSE VERMEIDEN. Wer auf einer Seite steht, auf der nichts
         passt, bekam bisher nur die Zahl 0 und keinen Weg weiter. Jetzt
         fuehrt ein Knopf in den gesamten Bestand fuer sein Modell —
         ueber alle Kollektionen hinweg, nicht nur diese. Der Knopf
         erscheint nur, wenn Shopify den Modellfilter wirklich anbietet
         (sonst zeigte er den ganzen Katalog, s. Block oben). */
      tat += '<a class="byg-garage-leiste__knopf" href="' + modellBasis(bike) + '?filter.p.m.byg.modelle=' +
        encodeURIComponent(bike.marke + ' ' + bike.modell) + '"><span>Alle Teile für die ' +
        text(bike.marke + ' ' + bike.modell) + '</span></a>';
    } else if (modellFilterVerfuegbar() &&
               new URLSearchParams(window.location.search).get('filter.p.m.byg.modelle') !== bike.marke + ' ' + bike.modell &&
               !eigeneModellseite(bike)) {
      /* Der ehrliche Weg: Shopify filtert, nicht wir. Steht der Filter
         schon auf diesem Bike (z. B. vom Hero-Waehler), gibt es nichts
         mehr zu tun — kein Knopf, der dieselbe Seite nochmal laedt.
         Ebenso auf der Modellseite des eigenen Bikes (/collections/ktm-
         250-sx mit gemerkter KTM 250 SX, 15.10.2026): dort ist die Liste
         schon genau dieses Modell, der gelbe Knopf aenderte nichts. */
      tat += '<a class="byg-garage-leiste__knopf" href="' + text(filterUrl(bike)) + '"><span>Nur Teile für mein Bike</span></a>';
    }
    /* UNSICHTBARER MODELLFILTER (15.10.2026, Abschlusspruefung). Shopify
       listet im Filter "Passende Modelle" hoechstens 100 Werte. Fehlt das
       Modell darunter (auf /collections/reifen sogar die KTM 250 SX, auf
       /collections/all z. B. TM RACING SMX 85), steht der Filter zwar in
       der Adresse, aber es gibt keine Pille und kein "Alle loeschen" —
       die Liste wirkt wie das ganze Sortiment, und zurueck kam man nur
       ueber "Bike entfernen". Dann bietet die Leiste den Weg selbst an:
       dieselbe Adresse ohne Modellfilter. Der Klick merkt sich das wie
       das Loeschen der Pille (autoKey), der Automatik-Filter springt
       danach nicht wieder an. */
    var ohneFilter = ganzesSortimentUrl();
    if (ohneFilter) {
      tat += '<a class="byg-garage-leiste__wechseln" data-byg-ganzes-sortiment href="' + text(ohneFilter) + '"><span>Ganzes Sortiment zeigen</span></a>';
    }
    /* Zur Uebersicht nach Bereichen (templates/collection.bike.json). */
    tat += '<a class="byg-garage-leiste__wechseln" href="' + modellBasis(bike) + '?view=bike&filter.p.m.byg.modelle=' +
      encodeURIComponent(bike.marke + ' ' + bike.modell) + '"><span>Nach Bereichen</span></a>';
    tat += '<a class="byg-garage-leiste__wechseln" href="/#bike"><span>Bike ändern</span></a>';

    var fuss = '';
    if (ohneAussage > 0) {
      /* Einzahl/Mehrzahl: "1 Artikel ... bleibt", "3 Artikel ... bleiben".
         Kleinigkeit, aber sie steht auf jeder Kollektionsseite. */
      /* KEINE VERMUTUNG UEBER DEN GRUND (05.10.2026). Hier stand
         "(Öl, Werkzeug, Universalteile)". Auf der Kolben-Seite waren es
         aber 22 S3-Trialkolben ohne jede Modellzuordnung — die Klammer
         erklaerte etwas, das nicht stimmte. Universalteile zaehlen ohnehin
         als Treffer (siehe oben); was hier uebrig bleibt, hat schlicht
         keine Zuordnung. */
      fuss = '<span class="byg-garage-leiste__fuss">' + ohneAussage +
        (ohneAussage === 1 ? ' Artikel hat keine Modellzuordnung und bleibt unmarkiert'
                           : ' Artikel haben keine Modellzuordnung und bleiben unmarkiert') +
        ' — bei Fragen zur Passung schreib uns, wir prüfen es vor der Bestellung.</span>';
    }
    leiste.innerHTML = '<div class="byg-garage-leiste__in">' + kopf + '<div class="byg-garage-leiste__tat">' + tat + '</div></div>' + fuss;
  }

  /* "<Modell> in der Garage merken" auf einer Modellseite: dasselbe wie
     der Hero-Waehler, nur ohne Baujahr (das ist dort optional). */
  document.addEventListener('click', function (e) {
    var k = e.target.closest ? e.target.closest('[data-byg-modell-merken]') : null;
    if (!k) return;
    var f = k.getAttribute('data-byg-modell-merken');
    try {
      var l = JSON.parse(window.localStorage.getItem(NEU));
      if (!Array.isArray(l)) l = [];
      l = l.filter(function (x) { return x && x.f && x.f !== f; });
      l.unshift({ f: f, jahr: null });
      window.localStorage.setItem(NEU, JSON.stringify(l.slice(0, 3)));
    } catch (err) {}
    var b = ausNeu();
    if (b) { try { window.localStorage.setItem(SCHLUESSEL, JSON.stringify(b)); } catch (err) {} }
    melde(b);
  });

  /* "Ganzes Sortiment zeigen" (15.10.2026): wie das Loeschen der Pille —
     fuer diese Kollektion und dieses Bike keinen Automatik-Filter mehr in
     dieser Sitzung. Der Link selbst fuehrt auf die Adresse ohne Filter. */
  document.addEventListener('click', function (e) {
    var k = e.target.closest ? e.target.closest('[data-byg-ganzes-sortiment]') : null;
    if (!k) return;
    var b = lies();
    if (!b) return;
    try { window.sessionStorage.setItem(autoKey(b), '1'); } catch (err) {}
  });

  document.addEventListener('click', function (e) {
    var k = e.target.closest ? e.target.closest('[data-byg-nur-passende]') : null;
    if (!k) return;
    var an = document.body.classList.toggle('byg-nur-passende');
    k.textContent = an ? 'Alle wieder zeigen' : 'Unpassende ausblenden';
  });

  /* Bike entfernen: Garage leeren und die Seite ohne Bike-Filter zeigen.
     Steht der Modellfilter in der Adresse, wird er herausgenommen (sonst
     bliebe die Liste auf das alte Bike gefiltert); sonst neu laden, damit
     ausgeblendete Karten und Markierungen sauber zurueckgesetzt sind. */
  document.addEventListener('click', function (e) {
    var k = e.target.closest ? e.target.closest('[data-byg-bike-entfernen]') : null;
    if (!k) return;
    k.disabled = true;
    loesche();
    var u = new URL(window.location.href);
    if (u.searchParams.has('filter.p.m.byg.modelle')) {
      u.searchParams.delete('filter.p.m.byg.modelle');
      u.searchParams.delete('page');
      if (u.searchParams.get('view') === 'bike') u.searchParams.delete('view');
      window.location.assign(u.pathname + u.search);
    } else {
      window.location.reload();
    }
  });

  function start() {
    alleBadges();
    zeichneLeiste();
    var w = document.querySelectorAll('[data-byg-garage-index]');
    for (var i = 0; i < w.length; i++) baueWaehler(w[i]);
  }

  document.addEventListener('byg:garage', function () { alleBadges(); zeichneLeiste(); });
  /* FILTERN OHNE SEITENWECHSEL. Shopify tauscht beim Filtern und bei
     "Mehr anzeigen" die Kartenliste aus, ohne die Seite neu zu laden.
     Die Leiste zeigte danach noch die alte Zahl ("24 Teile gelistet",
     obwohl der Bike-Filter geloescht war). Jetzt wird neu gezeichnet,
     sobald sich Adresse, Liste oder Kartenzahl aendern. */
  (function () {
    var suche = window.location.search, grid = null, zahl = -1, t = null;
    function stand() {
      var g = document.querySelector('#data-pagination, .product-grid');
      return { g: g, n: g ? g.children.length : 0 };
    }
    /* Die Passungstabelle (script[data-byg-passung]) tauscht Shopify dabei
       NICHT mit aus — sie gehoerte noch zur alten Liste, und die Leiste
       meldete "23 Artikel ohne Modellzuordnung", die sehr wohl eine haben.
       Deshalb wird sie ueber die Section-API frisch geholt, bevor neu
       gezeichnet wird.
       30.10.2026 (Manuel: nach "Mehr anzeigen" kamen unpassende Auspuffe):
       "Mehr anzeigen" setzt page=N in die Adresse. Hier wurde dann nur die
       Tabelle von Seite N geholt und die alte ERSETZT — die Karten der
       Seiten davor hatten keine Daten mehr, galten als "ohne Aussage" und
       wurden wieder eingeblendet. Jetzt werden alle Seiten bis N geholt
       (jede nur einmal) und zusammengefuehrt. Aendert sich die Adresse
       ausser der Seitenzahl (anderer Filter), beginnt die Sammlung neu. */
    var gesammelt = { basis: null, seiten: {}, daten: {} };
    function frischeKarte() {
      var el = document.querySelector('script[data-byg-passung]');
      var sec = el && el.closest('[id^="shopify-section-"]');
      if (!sec || !window.fetch || !window.DOMParser) return Promise.resolve();
      var u = new URL(window.location.href);
      var seite = parseInt(u.searchParams.get('page') || '1', 10) || 1;
      u.searchParams.delete('page');
      u.searchParams.set('section_id', sec.id.replace('shopify-section-', ''));
      var basis = u.toString();
      if (gesammelt.basis !== basis) gesammelt = { basis: basis, seiten: {}, daten: {} };
      /* Je Seite ein Abruf; ein zweiter Aufruf wartet auf laufende Abrufe mit. */
      var abrufe = [];
      for (var s = 1; s <= seite; s++) {
        if (!gesammelt.seiten[s]) {
          gesammelt.seiten[s] = (function (s, g) {
            var v = new URL(basis);
            if (s > 1) v.searchParams.set('page', s);
            return fetch(v.toString(), { credentials: 'same-origin' })
              .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
              .then(function (h) {
                var n = new DOMParser().parseFromString(h, 'text/html').querySelector('script[data-byg-passung]');
                if (n) { try { var d = JSON.parse(n.textContent); for (var k in d) g.daten[k] = d[k]; } catch (e) {} }
              })
              .catch(function () { g.seiten[s] = null; });
          })(s, gesammelt);
        }
        abrufe.push(gesammelt.seiten[s]);
      }
      return Promise.all(abrufe).then(function () {
        var jetzt = {};
        try { jetzt = JSON.parse(el.textContent) || {}; } catch (e) {}
        for (var k in gesammelt.daten) jetzt[k] = gesammelt.daten[k];
        el.textContent = JSON.stringify(jetzt);
      });
    }
    var s0 = stand(); grid = s0.g; zahl = s0.n;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var s = stand();
        if (window.location.search === suche && s.g === grid && s.n === zahl) return;
        suche = window.location.search; grid = s.g; zahl = s.n;
        frischeKarte().then(function () { alleBadges(); zeichneLeiste(); });
      }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  })();
  /* Ein zweiter Tab, der das Bike aendert, aktualisiert diesen mit. */
  window.addEventListener('storage', function (e) {
    if (e.key === SCHLUESSEL || e.key === NEU) { alleBadges(); zeichneLeiste(); }
  });
  /* Der Bike-Waehler meldet einen Wechsel auf derselben Seite. */
  document.addEventListener('byg:bike', function () { alleBadges(); zeichneLeiste(); });
  /* Der Knopf im Badge springt zum Waehler. */
  /* Baut den Waehler dort, wo geklickt wurde. Ohne Umweg, ohne
     Seitenwechsel, ohne dass der Kunde seinen Platz verliert. */
  function waehlerEinblenden(nahe) {
    var vorhanden = document.querySelector('[data-byg-garage-index]');
    if (vorhanden) {
      vorhanden.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var sf = vorhanden.querySelector('[data-byg-marke]');
      if (sf) sf.focus();
      return;
    }
    var pfad = indexPfad();
    if (!pfad) return;

    var alt = document.querySelector('.byg-garage-sofort');
    if (alt) { alt.querySelector('[data-byg-marke]').focus(); return; }

    var box = document.createElement('div');
    box.className = 'byg-garage-sofort';
    box.setAttribute('data-byg-garage-index', pfad);
    box.innerHTML =
      '<p class="byg-garage-sofort__kopf">Welches Bike fährst du?</p>' +
      '<div class="byg-garage__reihe">' +
        '<div class="byg-garage__feld"><label class="byg-garage__label" for="byg-sofort-marke">Marke</label>' +
          '<select class="byg-garage__select" id="byg-sofort-marke" data-byg-marke disabled><option value="">Marke wählen</option></select></div>' +
        '<div class="byg-garage__feld"><label class="byg-garage__label" for="byg-sofort-modell">Modell</label>' +
          '<select class="byg-garage__select" id="byg-sofort-modell" data-byg-modell disabled><option value="">Modell wählen</option></select></div>' +
        '<div class="byg-garage__feld"><label class="byg-garage__label" for="byg-sofort-jahr">Baujahr</label>' +
          '<select class="byg-garage__select" id="byg-sofort-jahr" data-byg-jahr disabled><option value="">Baujahr (optional)</option></select></div>' +
      '</div>' +
      '<div class="byg-garage__tat">' +
        '<button type="button" class="byg-garage__merken" data-byg-merken>Bike merken</button>' +
        '<button type="button" class="byg-garage__loeschen" data-byg-loeschen hidden>Bike vergessen</button>' +
      '</div>';
    var anker = nahe.closest('.byg-garage-badge, .byg-garage-leiste') || nahe;
    anker.parentNode.insertBefore(box, anker.nextSibling);
    baueWaehler(box);
    var sm = box.querySelector('[data-byg-marke]');
    if (sm) sm.focus();
  }

  document.addEventListener('click', function (e) {
    var k = e.target.closest ? e.target.closest('[data-byg-garage-oeffnen]') : null;
    if (!k) return;
    waehlerEinblenden(k);
  });

  /* Nach dem Merken verschwindet der eingeblendete Waehler wieder — die
     Antwort steht dann im Badge darueber. */
  document.addEventListener('byg:garage', function () {
    var sofort = document.querySelector('.byg-garage-sofort');
    if (sofort && lies()) sofort.remove();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
